import { useEffect, useState } from "react";
import apiClient from '../../config/apiClient';

const useUserRoleLocalStorage = () => {
  const [userRole, setUserRole] = useState(null);
  const [roleLoading, setRoleLoading] = useState(true);

  useEffect(() => {
    const getUserRoleFromLocalStorage = async () => {
      const userProfileString = localStorage.getItem("userProfile");

      if (!userProfileString) {
        setUserRole(null);
        setRoleLoading(false);
        return;
      }

      let userProfile;
      try {
        userProfile = JSON.parse(userProfileString);
      } catch (error) {
        localStorage.removeItem("userProfile");
        setUserRole(null);
        setRoleLoading(false);
        return;
      }

      const token = userProfile?.token?.token;

      if (!token) {
        setUserRole(null);
        setRoleLoading(false);
        return;
      }

      try {
        const response = await apiClient.post(
          `${process.env.REACT_APP_ROOT_URL}/auth/getUserInfo`
        );
        setUserRole(response.data.token.role);
      } catch (error) {
        console.log(error);
        localStorage.removeItem("userProfile");
        setUserRole(null);
      } finally {
        setRoleLoading(false);
      }
    };

    getUserRoleFromLocalStorage();
  }, []);

  return { userRole, roleLoading };
};

export default useUserRoleLocalStorage;
